// extracted by mini-css-extract-plugin
module.exports = {"top":"_80ad21f8ef--top--w9CUN","title":"_80ad21f8ef--title--Wa6w7"};